import BackofficeApplicationList from "components/BackofficeApplicationList";

export default function BackofficeHome(): JSX.Element {
	return <BackofficeApplicationList />;
}
